<template>
  <div id="app">
    <AppHeader v-if="!isLoginPage" />
    <router-view />
  </div>
</template>

<script setup>
import { onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from './stores/auth.js'
import AppHeader from './components/AppHeader.vue'

const route = useRoute()
const authStore = useAuthStore()

// Check if current page is login
const isLoginPage = computed(() => route.path === '/')

// Initialize authentication state on app startup
onMounted(async () => {
  // If tokens exist but no user data, fetch user data
  if (authStore.access && !authStore.user) {
    try {
      const response = await authStore.makeAuthenticatedRequest(`${import.meta.env.DEV ? 'http://192.168.0.200:8001/api' : '/api'}/users/me/`)
      authStore.setUser(await response.json())
    } catch (error) {
      console.warn('Failed to load user data on app initialization:', error)
      // If user data fetch fails, clear tokens as they might be invalid
      authStore.clearTokens()
    }
  }
})
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Montserrat:400,500,700,900");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  overflow-x: hidden;
  width: 100vw;
  position: relative;
}

html, body, #app {
  min-height: 100vh;
  width: 100%;
  font-family: 'Montserrat', sans-serif;
  background: 
    repeating-linear-gradient(
      -45deg,
      transparent,
      transparent 30px,
      rgba(255, 255, 255, 0.03) 30px,
      rgba(255, 255, 255, 0.03) 60px
    ),
    linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-attachment: fixed;
  background-size: cover;
  background-repeat: no-repeat;
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
  width: 100%;
}

/* Global modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  max-width: 100vw;
  max-height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  overflow-y: auto;
}

.modal-content {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  padding: 2rem;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 
    0 20px 60px rgba(0, 0, 0, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.4);
  position: relative;
  margin: auto;
}

li {
  list-style: none;
}

a {
  text-decoration: none;
  color: inherit;
}
.page-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 1.5rem;
}

.sub-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.85);
  margin-bottom: 1.25rem;
}

</style>
